//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// Maps to ExperienceLayoutType in experience-web-gateway
export enum ExperienceLayoutType {
  CAROUSEL = 'carousel',
  MASONRY = 'masonry',
  MULTISIZE_GRID = 'multisize-grid',
  SQUARE_GRID = 'square-grid',
  SINGLE_MEDIA = 'single-media',
  VIDEO_COMMERCE = 'video-commerce',
}
